import { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import useLoadingStore from "../../store/loading";
import { api } from "../../services/api";
import { errorsMessage } from "../../helpers";
import useModalStore from "../../store/modalStore";

export function useUser() {
  const [results, setResults] = useState();
  const [term, setTerm] = useState("");
  const [IdFilial, setIdFilial] = useState("");
  const [IdPerfil, setIdPerfil] = useState("");
  const [item, setItem] = useState(null);
  const [filiais, setFiliais] = useState([]);
  const [perfis, setPerfis] = useState([]);
  const { setLoadingTable } = useLoadingStore(state => state);
  const { modalOpen, showModal, hideModal } = useModalStore(state => state);

  useEffect(() => {
    getFiliais();
    getPerfis();
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilter = () => {
    const filters = {};
    if (term?.length > 0) filters.term = term;
    if (IdFilial) filters.IdFilial = IdFilial;
    if (IdPerfil) filters.IdPerfil = IdPerfil;
    return filters;
  };

  const getList = async (page = 1, limit = 10) => {
    try {
      setLoadingTable(true);

      const { data } = await api.get(`/users`, {
        params: {
          filters: handleFilter(),
          page,
          limit
        }
      });

      setResults(data?.data || {});
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    } finally {
      setLoadingTable(false);
    }
  };

  const getFiliais = async () => {
    try {
      const { data } = await api.get("/filiais", {
        params: {
          paginate: 0
        }
      });

      setFiliais(data?.data || []);
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    }
  };

  const getPerfis = async () => {
    try {
      const { data } = await api.get("/perfis", {
        params: {
          paginate: 0
        }
      });

      setPerfis(data?.data || []);
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    }
  };

  const handleSearch = () => {
    getList();
  };

  const handleShow = item => {
    setItem(item);
    showModal();
  };

  const handleClose = () => {
    setItem(null);
    hideModal();
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/users/${item.Id}`);
      handleClose();
      getList();
      enqueueSnackbar("Registro deletado com sucesso", {
        variant: "success"
      });
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    }
  };

  return {
    results,
    term,
    setTerm,
    handleSearch,
    handleShow,
    modalOpen,
    hideModal,
    handleClose,
    handleDelete,
    getList,
    IdFilial,
    setIdFilial,
    IdPerfil,
    setIdPerfil,
    filiais,
    perfis
  };
}
